import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostById } from '../utils/storage';
import { getCurrentUser, getProfile } from '../utils/auth';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function Post() {
  const { id } = useParams();
  const post = getPostById(id);
  const user = getCurrentUser();

  if (!post || post.author !== user?.username) {
    return (
      <div className="container">
        <h2>未找到文章</h2>
        <Link to="/">返回首页</Link>
      </div>
    );
  }

  return (
    <div className="container">
      <article className="post-full">
        <h1>{post.title}</h1>
        <div className="meta">{new Date(post.createdAt).toLocaleString()} {post.author ? (<span>• <Link to={`/user/${post.author}`}>{getProfile(post.author)?.displayName || post.author}</Link></span>) : null}</div>
        <div className="content"><ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown></div>
        <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
          <Link to="/" className="btn">返回</Link>
          {user && user.username === post.author && (
            <Link to={`/post/${id}/edit`} className="btn secondary">编辑</Link>
          )}
        </div>
      </article>
    </div>
  );
}
